<template>
<div id="contents">
     <!-- 头部组件 -->
     <component :is="header_"></component>
     <!--  -->
    <el-container class="el-container-vh" style="border: 1px solid #eee">
      <!-- 侧栏组件 -->
      <component :is="celan"></component>
      
      <el-container>
        <el-main>
          <el-table :data="tableData">
            <el-table-column align="center" width="80" prop="id" label="序号">
            </el-table-column>
            <el-table-column align="center" width="80" prop="paytype" label="类型">
            </el-table-column>
            <el-table-column align="center" width="80" prop="device" label="设备号">
            </el-table-column>
            <el-table-column align="center" prop="paymoney" label="金额">
            </el-table-column>
            <el-table-column prop="dingdan" label="订单号">
            </el-table-column>
            <el-table-column prop="ordername" label="商品名称">
            </el-table-column>
            <el-table-column prop="paytime" label="" align="left">
               <template slot-scope="scope" slot="header">
                  <span>时间</span>
                  <span>
                     <el-date-picker style="width:80%;display: inline-block;vertical-align: middle;padding-left: 0px;"
                      v-model="yuefen"
                      type="month"
                      placeholder="选择月"
                      format="yyyy-MM"
                      value-format="yyyy-MM">
                     </el-date-picker>
                  </span>
               </template> 
            </el-table-column>
            <el-table-column label="" align="left">
               <template slot="header">
                  <span>订单状态</span>
                  <el-dropdown style="display: inline-block;vertical-align: middle;padding-left: 0px;" @command="changeState">
                       <span class="el-dropdown-link">
                       <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="-1">支付失败</el-dropdown-item>
                      <el-dropdown-item command="1">支付成功</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
               </template>
               <template slot-scope="state">
                  <i v-if="state.row.state==1" style="color:#85ce61">支付成功</i>
                  <i v-if="state.row.state==-1" style="color:#ff0000">支付失败</i>
                  <i v-if="state.row.state==0" style="color:#e6a23c">待支付中</i>
               </template>
            </el-table-column>
            <el-table-column width="150" label="操作">
              <template slot-scope="scope">
                  <el-button type="danger" style="padding:7px 5px;" @click="del(scope.row.id)">
                    删除
                  </el-button>
                  <el-button type="danger" style="padding:7px 5px;" @click="hd(scope.row.id)">
                    点击回调
                  </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="8" 
            layout="total, prev, pager, next"
            :total="total">
          </el-pagination>

          </el-main>
      </el-container>
    </el-container>
</div>
</template>

<script>
//头部组件
import header_ from './header_.vue'
import celan from './celan.vue'
export default {
  name: 'header_',
   data() {
      return {
        tableData: [],
        total:null,
        header_:header_,
        celan:celan,
        yuefen:'',
        imglist:'./login.php',
        postUrl:'./post.php',
      }
    },
    methods: {
      //删除
      del(del_id){
          this.$http.post(this.imglist,{del_successpay:del_id},{emulateJSON:true}).then(res=>{
            this.tableData=res.body;
          });
      },
      //点击回调
      hd(hd_id){
          this.$http.post(this.imglist,{hd_successpay:hd_id},{emulateJSON:true}).then(res=>{
            this.tableData=res.body;
          });
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {

      },
      GetData(){
        this.$http.post(this.imglist,{successpay:true},{emulateJSON:true}).then(res=>{
            this.tableData=res.body;
        }); 
        //刷新让后端更新数据 
        // this.$http.post(this.postUrl,{postUrl:true},{emulateJSON:true}).then(res=>{
            // this.tableData=res.body;
        // }); 
      },
      //选择时间筛选数据
      changeState(item){
        var that=this;
        if (that.yuefen) {
          that.$http.post(that.imglist,{State:item,yuefen:that.yuefen},{emulateJSON:true}).then(res=>{
                let Data = [];
                for(let i in res.body){
                  Data.push(res.body[i]);
                };
                that.tableData=Data;
            });
        }else{
          this.$message.error('请输入时间');
        }
      }

    },
    created(){
        this.GetData();
      //刷新让后端更新数据     
      // setInterval(()=>{
        // this.GetData();
      // },3000);
       
    }
}
</script>


<style scoped>
.el-container-vh{
  height: 100vh;
}
@media screen and (max-width: 800px) {
  .el-container-vh{
    height: 100%;
  }
}
.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>


// WEBPACK FOOTER //
// src/components/successpay.vue